import {Fragment, useCallback} from 'react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import useTheme from '@material-ui/core/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import {useTranslation} from 'react-i18next';
import classNames from 'classnames';
import {Alert} from '@material-ui/lab';
import RenderLocalesColumn from './RenderLocalesColumn';
import MobileRow from './MobileRow';
import StandardRow from './StandardRow';
import Header from './Header';
import {ISingleDocument} from '../../services/utilis/ResponseObjects.types';

interface ISearchResultsProps {
  documents: ISingleDocument[]|undefined,
  title: string,
}

interface ISearchResultsTableProps {
  documents: ISingleDocument[]
}

const SearchResultsTable = ({documents}: ISearchResultsTableProps) => {
  const theme = useTheme();
  const smaller = useMediaQuery(theme.breakpoints.down('xs'));
  const {t} = useTranslation();

  const getTypeLabel = useCallback(
    (type) => t(`documentTypes.${type}` as any, type), [t],
  );

  const renderMobileRow = useCallback(
    (row) => (
      <MobileRow 
        cells={[
          {header: t('search-results.name'), value: row.name},
          {header: t('search-results.type'), value: getTypeLabel(row.type)},
          {header: t('search-results.locales'), value: <RenderLocalesColumn hit={row} />},
        ]} />
    ),
    [getTypeLabel, t]
  );

  const renderStandardRow = useCallback(
    (row) => (
      <StandardRow cells={[
        {value: row.name},
        {value: getTypeLabel(row.type)},
        {value: <RenderLocalesColumn hit={row} />}
      ]} />
    ),
    [getTypeLabel]
  );

  return (
    <TableContainer component={'div'} className={classNames('search-results-table-container', {'mobile': smaller})}>
      <Table className={'search-results-table'}>
        {!smaller && <Header />}
        <TableBody>
          {documents.map((row, index) => (
            <Fragment key={index}>
              {smaller ? renderMobileRow(row) : renderStandardRow(row)}
            </Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const SearchResultsSection = ({documents, title}: ISearchResultsProps) => {
  const theme = useTheme();
  const smaller = useMediaQuery(theme.breakpoints.down('xs'));
  const {t} = useTranslation();
  
  const isNotEmpty = documents && documents.length > 0;

  return (
    <div className="search-section-container">
      <div className="search-section-title">{title}</div>
      {isNotEmpty
        ? <SearchResultsTable documents={documents} /> 
        : <div className={classNames('alert-wrapper', {'mobile': smaller})}><Alert severity="info">{t('alerts.no-results')}</Alert></div>
      }
    </div>
    
  )
}

export default SearchResultsSection
